<script>
    import {state, pending, requested, myPosters, myUnclaimed, claimPosters,contractAddress,isStarted} from "./stores/contracts";
    import {unlock, unlock_requested,address, wallet_injected} from "./stores/wallet";

    import {tokenName} from "./stores/metadata";

    let viewState, transacting = false;
    let countInput;
    let _count = 0;
    let _inputError = false;
    let _errorText = "";

    let loadDots = "·..";
    let loadNum = 0;
    setInterval(()=>{
        loadNum = (loadNum + 1)%4;
        loadDots = "...";
        let dots = ("...").split("");
        if(loadNum < dots.length){
            dots[loadNum] = "·";
        }
        loadDots = dots.join("");
    },200);


    function updateCount(){

        if(countInput === ""){
            _count = 0;
            _inputError = false;
            return;
        }
        _count = parseInt(countInput);
        if(isNaN(_count)){
            _inputError = true;
            _errorText = "Invalid number"
            _count = 0;
        }else if(_count > $myUnclaimed.list.length) {
            _inputError = true;
            _errorText = "You can't claim that many"
        }else{
            _inputError = false;
        }
    }

    function openseaLink(_tokenId){
        return "https://opensea.io/assets/"+contractAddress.posters+"/"+_tokenId;
    }

    $:{
        transacting = $pending || $requested;

        if($myPosters.state === $myUnclaimed.state) {
            viewState = $myUnclaimed.state;
        }else if($myPosters.state === "error" || $myUnclaimed.state === "error"){
            viewState = "error";
        }else{
            viewState = "loading";
        }
    }

    function readCount(array){
        if(array.length === 0) {
            return "no";
        }else if(array.length === 1){
            return "one";
        }else{
            return array.length;
        }
    }
    function pluralise(array,singular,plural){
        return array.length === 1?singular:plural;
    }


    function claimPress(){
        // console.log(">>",_count);
        claimPosters(_count);
    }
    function claimAllPress(){
        claimPosters($myUnclaimed.list.length);
    }

    const posterData = [
        {
            name: "70s Poster",
            url: "https://flat-fuchsia-fairy.fission.app/image/70s_Poster.jpg",
        },
        {
            name: "SciFi Poster",
            url: "https://flat-fuchsia-fairy.fission.app/image/SciFi_Poster.jpg"
        },
        {
            name: "90s Poster",
            url: "https://flat-fuchsia-fairy.fission.app/image/90s_Poster.jpg"
        }

    ]

</script>

<h1>Stoner Cats Posters</h1>


<style>
    .posters{
        margin-top:50px;
    }

    .poster{
        margin-bottom: 15px;
        width:200px;
    }
</style>
<div>
{#if $state === "initial"}
    {#if !$wallet_injected}
        <div>This site requires a Web3 enabled browser. </div>
        <div>Please ensure your Web3 wallet is unlocked in order to connect.</div>
    {:else if !$unlock_requested}
        <button on:click={unlock}>Connect Web3 Wallet</button>
    {:else}
        <div>{loadDots}</div>
    {/if}
{:else if $state === "loading"}
    <div>Loading...</div>
{:else if $state === "loaded"}
<!--    <div>-->
<!--        CONNECTED!-->
<!--    </div>-->
{:else if $state === "network"}
    <div>Incorrect network. Please connect to Mainnet.</div>
{:else}
    <div class="error">Web3 wallet error</div>
{/if}


    {#if $state === "loaded"}
        {#if !$isStarted.value}

            <div>coming soon...</div>


        {:else if viewState === "initial" }
            ...
        {:else if viewState === "loading"}
            Loading poster data{loadDots}
        {:else if viewState === "error"}
            Error getting poster data
        {:else}


        <!--loaded-->
            <div class="claimData">You have {readCount($myUnclaimed.list)} unclaimed {pluralise($myUnclaimed.list,"poster","posters")}.</div>
            {#if $myUnclaimed.list.length > 0}
                {#if $myUnclaimed.list.length === 1}
                    {#if transacting }
                        <div>{loadDots}</div>
                    {:else}
                        <button on:click={claimAllPress}
                                disabled={transacting}>
                            Claim
                        </button>
                    {/if}
                {:else}
                    <h2>Claim posters:</h2>
                    <div>
                        <input
                                class="input-field"
                                disabled={transacting}
                                bind:value={countInput}
                                on:change={updateCount}
                                on:keyup={updateCount}
                                type="text"/>
                        {#if transacting }
                            <div>{loadDots}</div>
                        {:else if _inputError}
                            <span class="spacer error"> !!!!</span>
                            <div class="info error">Error: {_errorText}</div>
                        {:else if _count === 0}
                            <span class="spacer"> &lt;&lt;&lt;&lt;</span>
                            <div class="info">(Enter number to claim)</div>
                        {:else if _count > 0}
                            <button on:click={claimPress}
                                    disabled={transacting}>
                                Claim
                            </button>
                            <div class="info">&nbsp;</div>
                        {/if}
                    </div>
                    <div class="divider">------ or ------</div>
                    <div>
                        {#if transacting}
                            <div>{loadDots}</div>
                        {:else}
                            <button
                                    on:click={claimAllPress}
                                    disabled={transacting}
                            >
                                Claim all
                            </button>
                        {/if}
                    </div>
                {/if}
            {/if}



            {#if $myPosters.list.length > 0}
                <div class="divider2">===============</div>
                <h3>Your posters:</h3>

                {#each $myPosters.list as tokenId }
                    <div><a target="_blank" href="{openseaLink(tokenId)}">{tokenName(tokenId)}</a></div>
                {/each}
            {/if}
        {/if}



    {/if}

    <div class="posters">
        {#each posterData as poster}
            <a target="_blank" href="{poster.url}">
                <img src="{poster.url}" class="poster" alt="{poster.name}">
            </a>
        {/each}
    </div>

    <div>
        <a href="https://opensea.io/collection/stoner-cats-posters" target="_blank">View on OpenSea</a>
    </div>
</div>

